import FormButtonsLayout from '../ui/layout/form/FormButtons/FormButtonsLayout';
import React, { useEffect } from 'react';
import FormTemplate, { FormTemplateProps } from './FormTemplate';
import { useMessageService } from 'framework/ui/Message';
import { SxProps } from '@mui/material';

interface ModalFormProps extends FormTemplateProps {
  closeModal: () => void;
  modalOpen: boolean;
  isHideDefaultButtons?: boolean;
  isCloseAfterSubmit?: boolean;
  submitButtonText?: string;
  actionsSx?: SxProps;
  messageComponent?: React.ReactNode;
}

export const MESSAGE_MODAL_FORM_CONTEXT = 'modalForm';

const ModalForm = ({
  children,
  closeModal,
  afterSubmit = {},
  modalOpen,
  isHideDefaultButtons = false,
  isCloseAfterSubmit = true,
  submitButtonText,
  actionsSx,
  messageComponent,
  ...props
}: ModalFormProps) => {
  const { cleanMessage } = useMessageService(MESSAGE_MODAL_FORM_CONTEXT);
  const { execute = () => {} } = afterSubmit;

  useEffect(() => {
    if (modalOpen) {
      cleanMessage();
    }

    // Suppressed warnings because we only need to call useEffect callback after
    // the modal has been opened with no calls after the messages have changed.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modalOpen]);

  return (
    <FormTemplate
      {...props}
      afterSubmit={{
        ...afterSubmit,
        execute: response => {
          if (execute) {
            execute(response);
          }
          isCloseAfterSubmit && closeModal();
        },
      }}
      messageContext={MESSAGE_MODAL_FORM_CONTEXT}
    >
      <>
        {React.Children.map(children, child =>
          React.isValidElement<any>(child) ? React.cloneElement(child, { closeModal }) : child,
        )}
        {!isHideDefaultButtons && (
          <FormButtonsLayout
            messageComponent={messageComponent}
            actionsSx={actionsSx}
            onCancelAction={closeModal}
            submitButtonText={submitButtonText}
          />
        )}
      </>
    </FormTemplate>
  );
};

export default ModalForm;
